import * as React from 'react';

export const Ticket = () => (
  <svg viewBox='0 0 65 65'>
    <path
      d={`M47.1 17.4c-2.7-2.7-2.7-7.2 0-9.9L40.6 1 1 40.6l6.5 6.5c2.7-2.4 6.9-2.3 9.6.3 2.6 2.6 \
      2.7 6.8.3 9.6l6.5 6.5 39.6-39.6-6.5-6.5c-2.8 2.7-7.2 2.7-9.9 0zM13.9 28.7l1.4 1.4`}
      fill='none'
      stroke='#FE7662'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M17.9 32.8l14.5 14.5'
      fill='none'
      stroke='#FE7662'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeDasharray='3.74,3.74'
    />
    <path
      d='M33.8 48.7l1.4 1.4'
      fill='none'
      stroke='#FE7662'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);


// WEBPACK FOOTER //
// src/app/src/components/Icons/Ticket.tsx